import defaultTo from 'lodash/fp/defaultTo';
import flow from 'lodash/fp/flow';
import has from 'lodash/fp/has';
import head from 'lodash/fp/head';
import split from 'lodash/fp/split';

import { config } from '../../configuration/config';

interface LocaleMap {
    [key: string]: string;
}

const supportedLocaleMap: LocaleMap = {
    'bg-BG': 'bg-BG',
    bg: 'bg-BG',
    'cs-CZ': 'cs-CZ',
    cs: 'cs-CZ',
    'da-DK': 'da-DK',
    da: 'da-DK',
    'de-DE': 'de-DE',
    de: 'de-DE',
    'el-GR': 'el-GR',
    el: 'el-GR',
    'en-GB': 'en-GB',
    en: 'en-GB',
    'es-ES': 'es-ES',
    es: 'es-ES',
    'et-EE': 'et-EE',
    et: 'et-EE',
    'fi-FI': 'fi-FI',
    fi: 'fi-FI',
    'fr-FR': 'fr-FR',
    fr: 'fr-FR',
    'hr-HR': 'hr-HR',
    hr: 'hr-HR',
    'hu-HU': 'hu-HU',
    hu: 'hu-HU',
    'it-IT': 'it-IT',
    it: 'it-IT',
    'ko-KR': 'ko-KR',
    ko: 'ko-KR',
    'lt-LT': 'lt-LT',
    lt: 'lt-LT',
    'lv-LV': 'lv-LV',
    lv: 'lv-LV',
    'nb-NO': 'nb-NO',
    nb: 'nb-NO',
    'nl-NL': 'nl-NL',
    nl: 'nl-NL',
    'pl-PL': 'pl-PL',
    pl: 'pl-PL',
    'pt-BR': 'pt-BR',
    'pt-PT': 'pt-PT',
    pt: 'pt-PT',
    'ro-RO': 'ro-RO',
    ro: 'ro-RO',
    'sk-SK': 'sk-SK',
    sk: 'sk-SK',
    'sl-SI': 'sl-SI',
    sl: 'sl-SI',
    'sv-SE': 'sv-SE',
    sv: 'sv-SE',
};

const DEFAULT_LOCALE = config.login.defaultLocale;

const extractLanguage = flow(defaultTo(DEFAULT_LOCALE), split('-'), head);

const DEFAULT_LANG = extractLanguage(DEFAULT_LOCALE);

const getSupportedLocale = (preferredLocale: string): string =>
    has(preferredLocale, supportedLocaleMap) ? supportedLocaleMap[preferredLocale] : DEFAULT_LOCALE;

export { DEFAULT_LANG, DEFAULT_LOCALE, extractLanguage, supportedLocaleMap, getSupportedLocale };
